import React from "reactn"
import { Box, useRadio } from "@chakra-ui/react"
import { IngmarsonCard }  from "./card"

export function RadioCard(props) {
  const { isAvailable } = props
  const variant = isAvailable ? 'radioButton' : 'radioButtonNoStock'
  const { getInputProps, getCheckboxProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label">
      <input {...input} />
      <IngmarsonCard id="radioCard"
        variant={variant}
        {...checkbox}        
      >
        {props.children}
      </IngmarsonCard>
    </Box>
  )
}




